import React, { useState } from "react";

const RadioGroup = ({ field, value, setFieldValue, options = [] }) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleRadioChange = (newValue) => {
        setSelectedValue(newValue);
        setFieldValue(field, newValue);
    };

    return (
        <div className="radio-group-container">
            {options.map((option) => (
                <div key={option} className="radio-container">
                    <input
                        className="radio-input"
                        type="radio"
                        id={option}
                        value={option}
                        checked={selectedValue === option}
                        onClick={() => handleRadioChange(option)}
                    />
                    <label
                        htmlFor={option}
                        className={`radio-label ${value === option ? "bold-label" : ""}`}
                    >
                        {option}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default RadioGroup;
